/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Chip from '@material-ui/core/Chip';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Avatar from '@material-ui/core/Avatar';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
	root: {
		minWidth: 190
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary
	},
	IconColor: {
		color: 'white'
	}
});

class index extends Component {
	// NOSONAR

	confirmationOndelete = () => {
		Swal.fire({
			
			title: this.props.t('sweetalert_title.are_you_sure'),
			text: this.props.t('sweetalert.confirmation_on_delete_funding_source'),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			cancelButtonText: this.props.t('buttons.cancel'),
			confirmButtonText: this.props.t('buttons.ok'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				this.props.OnDelete();
			}
		});
	};

	render() {
		const { t } = this.props;
		return (
			<ListItem>
				<ListItemAvatar>
					<Avatar>
						<AccountBalanceIcon />
					</Avatar>
				</ListItemAvatar>
				<ListItemText
					primary={`${this.props.institution_name} *${this.props.account_mask}`}
					secondary={this.props.type}
				/>
				<div className="butttons-account">
					<Chip
						color="outlined"
						icon={<DeleteOutlineIcon />}
						label={t('buttons.delete')}
						onClick={this.confirmationOndelete}
						size="small"
					/>
				</div>
			</ListItem>
		);
	}
}

export default withStyles(styles)(withTranslation()(index));
